<template>
  <div class="team">
    <page-header />
    <page-prompt />
    <audit-temp :final_audit_status="final_audit_status" :final_audit_remark="final_audit_remark" />
    <section class="main">
      <h2 class="title">参赛者</h2>
      <div class="msgs">
        <div class="student" v-for="item of student_list" :key="item.id">
          <ul>
            <li>
              <label>姓名：</label>
              <span>{{ item.name }}</span>
            </li>
            <li>
              <label>队内排名</label>
              <span>{{ item.position }}</span>
            </li>
            <li>
              <label>身份证号</label>
              <span>{{ item.identity }}</span>
            </li>
            <li>
              <label>性别：</label>
              <span>{{ sex_config_obj[item.sex] }}</span>
            </li>
            <li>
              <label>手机号：</label>
              <span>{{ item.phone }}</span>
            </li>
            <li>
              <label>电子邮箱：</label>
              <span>{{ item.email }}</span>
            </li>
            <li>
              <label>学校名称：</label>
              <span>{{ item.school_name }}</span>
            </li>
            <li>
              <label>学院名称：</label>
              <span>{{ item.college }}</span>
            </li>
            <li>
              <label>专业名称：</label>
              <span>{{ item.major }}</span>
            </li>
            <li>
              <label>学号：</label>
              <span>{{ item.student_id }}</span>
            </li>
            <li>
              <label>学生类型：</label>
              <template v-for="it of student_type2_config">
                <span :key="it.id" v-if="it.id === item.student_type">{{ it.name }}</span>
              </template>
            </li>
            <li>
              <label>入学年份：</label>
              <span>{{ item.dates }}</span>
            </li>
            <li>
              <label>年级：</label>
              <span>{{ item.grade }}</span>
            </li>
          </ul>
        </div>
      </div>
      <div class="btn">
        <el-button type="primary" icon="el-icon-back" @click="onPrevPage">返回上一项</el-button>
        <el-button type="primary" icon="el-icon-right" @click="onNextPage">下一项</el-button>
      </div>
    </section>
  </div>
</template>

<script>
import PageHeader from '@/components/PageHeader'
import AuditTemp from '@/components/AuditTemp'
import PagePrompt from '@/components/PagePrompt'
import { fetchStudentList } from '@/service/api'

export default {
  name: 'PageTeam',
  components: {
    PageHeader,
    AuditTemp,
    PagePrompt
  },
  data () {
    return {
      final_audit_status: 3,
      final_audit_remark: '',
      sex_config_obj: {
        1: '男',
        2: '女'
      },
      student_list: [],
      ac_student: {
        student_type: ''
      },
      student_type2_config: []
    }
  },
  methods: {
    async getStudentList () {
      try {
        const data = await fetchStudentList()
        this.student_list = data.reg_student_list
        this.final_audit_status = data.reg_team_basic.final_audit_status
        this.final_audit_remark = data.reg_team_basic.final_audit_remark
        this.student_type2_config = data.student_type2_config
      } catch (error) {
        console.log('getStudentList error', error)
      }
    },
    onPrevPage () {
      this.$router.push('/basic')
    },
    onNextPage () {
      this.$router.push('/instructor')
    }
  },
  mounted () {
    document.body.style.height = 'auto'
    this.getStudentList()
  },
  unmounted () {
    document.body.style.height = '100%'
  }
}
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>
